export const APP_ID = "st-login-handler";
export const APP_DATA = "stLoginHandlerAppData";

export const ENV_DEV = "dev";
export const ENV_BETA = "beta";
export const ENV_PROD = "prod";

export const SIGN_UP_LINK_ID = "link-to-sign-up";
export const LOGIN_LINK_ID = "link-to-login";
export const FORGOT_PASSWORD_LINK_ID = "link-to-forgot-password";
export const RETURN_TO_LOGIN_LINK_ID = "link-to-return-to-login";

export const FORM = "form";
export const MODAL = "modal";

export const FORM_SUBMIT_MESSAGE_CONTAINER_ID = `${APP_ID}-form-submit-message-container`;

export const SUCCESS_BACKGROUND_CLASS = `${APP_ID}-bg-success`;
export const DANGER_BACKGROUND_CLASS = `${APP_ID}-bg-danger`;

// update before each publish
export const APP_VERSION = "2.1.1";

export const SHOPTYPE_PAGE_LINK = "https://www.shoptype.com/";

export const LOG_IN_WITH_GOOGLE_BUTTON_ID = "log-in-with-google";
export const LOG_IN_WITH_FACEBOOK_BUTTON_ID = "log-in-with-facebook";

export const PROVIDER_GOOGLE = "GOOGLE";
export const PROVIDER_FACEBOOK = "FACEBOOK";

export const DOMAIN_SHOPTYPE = "SHOPTYPE";

export const INCORRECT_COSELL_DETAILS_MESSAGE = `client cosell details has not been provided or it is provided but is not an object.
when isCosell is true, cosell object must include these properties:
{
  ...,
  isCosell: true,
  cosell: {
    token: "user-authorization-token", // optional, needed if the user is already logged in and the user token is available
    origin: "publish-link-page-origin", // example: "https://app.shoptype.com", the origin of the product page URL
    productId: "id-of-the-product-being-published",
    productVendorId: "vendor-id-of-the-product-being-published"
  }
}`;

export const DEV_WIDGET_URL = 'https://shoptype-scripts.s3.amazonaws.com/Widgets/ShoptypeDevWidget_0.1.2.js';
export const BETA_WIDGET_URL = 'https://shoptype-scripts.s3.amazonaws.com/Widgets/ShoptypeStagingWidget_0.1.2.js';
export const PROD_WIDGET_URL = 'https://shoptype-scripts.s3.amazonaws.com/Widgets/ShoptypeProductionWidget_0.1.2.js';

export const SOCIAL_MEDIA_PLATFORM_SHARE_URL = {
    facebook: "https://www.facebook.com/sharer/sharer.php",
    twitter: "https://twitter.com/share",
    pinterest: "https://pinterest.com/pin/create/button",
    whatsapp: "https://web.whatsapp.com/send"
};

export const MEDIUM_COPY = "copy";
export const MEDIUM_EMBED = "embed";

export const SOCIAL_MEDIA_PLATFORMS = {
    facebook: "facebook",
    twitter: "twitter",
    pinterest: "pinterest",
    whatsapp: "whatsapp"
};

export const GOOGLE_LOGO_CODE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAASxQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFQAAABIAAA8AGAwAHAkJCRoJIggIBx0PJA8HBxUpBiANJg0GJR8AMiEACiQQMg8KOhINRRIPSzYASTgDETYbETUaTBcRGDBXGjdjXhoVHjlpHjlqHTxsGU0nIUN5e04IHFgsHFosYGASHmAuhygfiCgflG8EjSkhl3IDIm83JHQ5oS8kLl2qJXc7LVyqL16rqTAlqTEnsDMnJ4A+uDUpKoNBKodENW3IxjktOXTVLZBH2KIEyjot2qMELpdKPHne1Dww1T0wMJtMO3/Q2z8xMaBP4EAyQYLv5kI0M6NR+LoFQoTz+boF6kM1TqlI6UM17VctOpibNKhTN6B3QoX0QobxdK4660M177sK8XAj+rcH+7wFvU5rcQAAAFp0Uk5TAAECAwQGBwkMDhEVGx0eIyMlKCgpLjEzOUZHSUxNTVViYmZnanB6fICAgoqOjpGUlqOqqq2urq6xsrm8wsTIzdLW19fY2uHj4+Po6evt8Pb2+Pn6+vv8/P3+LPz/7gAAALxJREFUGNNjYAACYR2HgFBPYzlGBjBg1Q2PhwAbPhCfzSoeBvwkQAL6QJaLogCPpIWPOIgvGhEfb8kO1ssNJg2SEj04GJCAa3KyOohWVgMDFYaQ5GQpkIBjDBj4MwQlJ0sjCQQzOCcna4EElIDqzWNi3Bn0EuK8uKDmmcTEmDGIhEVFWXOC+QpALfIMDNpRUVFuqmJCMkaRsTH2zAwMLKZRMBDtLQhSyawZCBWw44caxqth6+XrZCjLBGQDAEk+LRJxL3qGAAAAAElFTkSuQmCC";
export const FACEBOOK_LOGO_CODE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAMlQTFRFAAAAAAAAAA0bAA0aAAwYAAwXAAsWAAsVDDZsCzduCzdtCzZvCzhwCzdxCzl0DTl0DTh1DTp0DTl1D0mUD0uXD0uaDkucEVWsEVauEVawElexElexN262Eli0OXC1FGTLFGXOFGXOFWfRFWfR3d3dF3LnF3LoF3LoF3PpF3LqS5X1JoDzRZH1SZT1WZ32YaL2Z6X2ebD3e7L4kL75wtv8/v7//v//GHfyHHryKIDzNon0Po30P470SJP1Y6P2l8L5vtn7x978////+exjcgAAADd0Uk5TAAETFBUWFxhtb3BxcnN1dXZ3eJaanJ+ztLS2uLm6u9TV1tna2/Ly8/T1/f7+/v7+/v7+/v7+/n9IN00AAACiSURBVBjTTY/HFoJADACDqKCIYu9iQQULVli7kv//KLPBwhzyJnPYtwEgVKNl2818CmKU3FwwU13hvSZ+VGUxWM/P6LgVQgfIuBwiRDwIMVOhyPsF8fW4khjQ5XBHXLO0YfwNK5YhTGgughAxDDakI+jLgMyNtANlmkt/j7jzT6QmaF7yDTcNUEqGgvx64x/q8TGWFwfXVD73apWB4/SsrPQ3ZgMoivO3DBAAAAAASUVORK5CYII=";
export const SHOPTYPE_LOGO_CODE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAjtJREFUOE+lkz1ok1EUhp9zv68J+WmladNq0x/FSikuUgdFRNTBwbpbi6OQip0c3Do56eSgFnFxVlwUB50UkYIgChqDwbZQf0pitba2TfN9+e6RJNT+GCcP3OHCuQ/nPfd9RVWV/yipB1ANEDGgAdbLY0IdqCiCQPWs1xZAbZhg4SkE80jDdvTXM0zyHMHcPZwdI1VADVSrDQClvPgSWX4OkV7wckg4BURhNYstL2BaR7Ern3CbD9UHWP8bOjUIbSNIQzNUZJg4lJfQUg6ZvY5uG8XpvrQZUNHsT1/FLD1A2o9CuAsNpTAN/VRFlV6jXh4pZtFyO7h9uKmhmpzKEisfYf0CfBiExG40NoCJnkaLr8AWIXoAVu7CchbNZ7BtaUJd6XVAsDxF8G4Y09SGNMWh8Qj6I4OJF6rjB0u7MMl+9Ms18BLQksbpPItIaG2CgGDuEVoYx/ARbT+P/T6DW7wFFsqRNCbZC/NPUC+GXV7E2TuOG+taA1j8yStI4TYm0Q/hCNp+mWD6DiJges6gs2NIEEfn3uAMPMZEujd+o8X/+hBW36OlDMbxUcdHYgerZpKVDDYIoOShxRK67TjhvosbAUrF0F52DPl8E+k8BXYe3CgsTCDx/VhthJn7OMdyOJGOP47cZCT/51uceA/eixOIK0i4FdTDLk5iuitbj2JaDuMm9tUz0rq/S7kbuDuH8CeGcfdcwK4WINxBKHXyr9jVDVOtSwlW8phIEhGnet8apC1Z+Fem6z9c6/4NA4of3/SbxK8AAAAASUVORK5CYII=";
export const COSELL_STEPS_LOGO = {
    step1: { code: "data:image/png;base64,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", alt: "become a member" },
    step2: { code: "data:image/png;base64,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", alt: "explore shop" },
    step3: { code: "data:image/png;base64,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", alt: "cosell and earn" }
};
export const SOCIAL_MEDIA_LOGO = {
    facebook: { code: "data:image/png;base64,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", alt: "facebook" },
    twitter: { code: "data:image/png;base64,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", alt: "twitter" },
    pinterest: { code: "data:image/png;base64,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", alt: "pinterest" },
    whatsapp: { code: "data:image/png;base64,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", alt: "whatsapp" }
};

export const SOCIAL_MEDIA_SHARE_BUTTON_ID = {
    facebook: `${APP_ID}-social-media-share-facebook`,
    twitter: `${APP_ID}-social-media-share-twitter`,
    pinterest: `${APP_ID}-social-media-share-pinterest`,
    whatsapp: `${APP_ID}-social-media-share-whatsapp`,
};

export const RESEND_OTP_BUTTON_DEFAULT_TEXT = "Resend OTP";

export const FORM_SUBMIT_STATUS = {
    success: "success",
    failed: "failed"
};

// facebook app id
export const FACEBOOK_APP_ID = "908250310106079";
// google client id
export const GOOGLE_CLIENT_ID = "303271545753-dnnm7vmokdg7vhlgtmogk3oajrb0v0sg.apps.googleusercontent.com";

export const VALID_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const PASSWORD_PATTERN_REGEX = /^.{6,}$/;

export const LOGIN_FORM = "loginForm";
export const SIGN_UP_FORM = "signUpForm";
export const SIGN_UP_OTP_FORM = "signUpOtpForm";
export const COSELL_PUBLISH_FORM = "cosellPublishForm";
export const FORGOT_PASSWORD_FORM = "forgotPasswordForm";
export const RESET_PASSWORD_FORM = "resetPasswordForm";

export const FORM_CONTROL_ERROR_CLASS = {
    input: `${APP_ID}-form-input-error`
};

export const FORM_CONTROL_FIELDS = {
    resetPasswordForm: {
        input: ["password", "confirmPassword", "emailOtp"],
        error: ["passwordError", "confirmPasswordError", "emailOtpError"]
    }
};

export const LOGIN_FORM_CONTROL_FIELD_LIST = ["email", "password", "all"];
export const SIGN_UP_FORM_CONTROL_FIELD_LIST = ["email", "password", "confirmPassword", "firstName", "lastName", "mobile", "all"];
export const SIGN_UP_OTP_FORM_CONTROL_FIELD_LIST = ["emailOtp", "all"];
export const FORGOT_PASSWORD_FORM_CONTROL_FIELD_LIST = ["email", "all"];
export const RESET_PASSWORD_FORM_CONTROL_FIELD_LIST = ["password", "confirmPassword", "emailOtp", "all"];

export const FORM_CONTROL_FIELD = {
    email: "email",
    password: "password",
    confirmPassword: "confirmPassword",
    firstName: "firstName",
    lastName: "lastName",
    emailOtp: "emailOtp",
    mobile: "mobile",
    all: "all"
};

export const FORM_CONTROL = {
    loginForm: {
        email: { id: `${APP_ID}-login-email`, name: "email" },
        emailError: { id: `${APP_ID}-login-email-error`, name: "emailError" },
        password: { id: `${APP_ID}-login-password`, name: "password" },
        passwordError: { id: `${APP_ID}-login-password-error`, name: "passwordError" }
    },
    signUpForm: {
        firstName: { id: `${APP_ID}-sign-up-first-name`, name: "firstName" },
        firstNameError: { id: `${APP_ID}-sign-up-first-name-error`, name: "firstNameError" },
        lastName: { id: `${APP_ID}-sign-up-last-name`, name: "lastName" },
        lastNameError: { id: `${APP_ID}-sign-up-last-name-error`, name: "lastNameError" },
        email: { id: `${APP_ID}-sign-up-email`, name: "email" },
        emailError: { id: `${APP_ID}-sign-up-email-error`, name: "emailError" },
        password: { id: `${APP_ID}-sign-up-password`, name: "password" },
        passwordError: { id: `${APP_ID}-sign-up-password-error`, name: "passwordError" },
        confirmPassword: { id: `${APP_ID}-sign-up-confirm-password`, name: "confirmPassword" },
        confirmPasswordError: { id: `${APP_ID}-sign-up-confirm-password-error`, name: "confirmPasswordError" },
        mobile: { id: `${APP_ID}-sign-up-mobile`, name: "mobile" },
        mobileError: { id: `${APP_ID}-sign-up-mobile-error`, name: "mobileError" },
    },
    signUpOtpForm: {
        emailOtp: { id: `${APP_ID}-sign-up-email-otp`, name: "emailOtp" },
        emailOtpError: { id: `${APP_ID}-sign-up-email-otp-error`, name: "emailOtpError" },
    },
    cosellPublishForm: {
        shareLink: { id: `${APP_ID}-cosell-publish-share-link`, name: "shareLink" },
        embedCode: { id: `${APP_ID}-cosell-publish-embed-code`, name: "embedCode" },
    },
    forgotPasswordForm: {
        email: { id: `${APP_ID}-forgot-password-email`, name: "email" },
        emailError: { id: `${APP_ID}-forgot-password-email-error`, name: "emailError" },
    },
    resetPasswordForm: {
        password: { id: `${APP_ID}-reset-password-password`, name: "password" },
        passwordError: { id: `${APP_ID}-reset-password-password-error`, name: "passwordError" },
        confirmPassword: { id: `${APP_ID}-reset-password-confirm-password`, name: "confirmPassword" },
        confirmPasswordError: { id: `${APP_ID}-reset-password-confirm-password-error`, name: "confirmPasswordError" },
        emailOtp: { id: `${APP_ID}-reset-password-email-otp`, name: "emailOtp" },
        emailOtpError: { id: `${APP_ID}-reset-password-email-otp-error`, name: "emailOtpError" },
    }
};

export const LOGIN_FORM_CONTROL_ID_LIST = Object.values(FORM_CONTROL.loginForm).map(formControl => formControl.id);
export const SIGN_UP_FORM_CONTROL_ID_LIST = Object.values(FORM_CONTROL.signUpForm).map(formControl => formControl.id);
export const SIGN_UP_OTP_FORM_CONTROL_ID_LIST = Object.values(FORM_CONTROL.signUpOtpForm).map(formControl => formControl.id);
export const FORGOT_PASSWORD_FORM_CONTROL_ID_LIST = Object.values(FORM_CONTROL.forgotPasswordForm).map(formControl => formControl.id);
export const RESET_PASSWORD_FORM_CONTROL_ID_LIST = Object.values(FORM_CONTROL.resetPasswordForm).map(formControl => formControl.id);

export const FORM_SUBMIT_BUTTON_ID = {
    loginForm: {
        submitButton: `${APP_ID}-login-form-submit`
    },
    signUpForm: {
        submitButton: `${APP_ID}-sign-up-form-submit`
    },
    signUpOtpForm: {
        resendEmailOtp: `${APP_ID}-sign-up-otp-form-resend-email-otp`,
        submitButton: `${APP_ID}-sign-up-otp-form-submit`
    },
    cosellStepsForm: {
        proceedToRegister: `${APP_ID}-cosell-steps-form-proceed-to-register`
    },
    cosellPublishForm: {
        copyShareLink: `${APP_ID}-cosell-publish-form-copy-share-link`,
        copyEmbedCode: `${APP_ID}-cosell-publish-form-copy-embed-code`
    },
    forgotPasswordForm: {
        submitButton: `${APP_ID}-forgot-password-form-submit`
    },
    resetPasswordForm: {
        submitButton: `${APP_ID}-reset-password-form-submit`
    }
};

export const FORM_FIELD_ERROR_MESSAGE = {
    email: {
        required: "Email is required",
        invalid: "Email is invalid",
        valid: ""
    },
    password: {
        required: "Password is required",
        invalid: "Password should be longer than 6 characters",
        valid: ""
    },
    confirmPassword: {
        required: "Retype password to confirm",
        invalid: "Passwords do not match",
        passwordNotFilled: "First type password",
        passwordIsInvalid: "First type valid password",
        valid: ""
    },
    firstName: {
        required: "First name is required",
        valid: ""
    },
    lastName: {
        required: "Last name is required",
        valid: ""
    },
    mobile: {
        required: "Mobile number is required",
        invalid: "Mobile number is invalid",
        valid: ""
    },
    emailOtp: {
        required: "OTP is required",
        valid: ""
    }
};

export const FORM_SUBMIT_SUCCESS_DEFAULT_MESSAGE = {
    resetPasswordForm: "Password changed successfully"
};

export const FORM_SUBMIT_ERROR_DEFAULT_MESSAGE = {
    loginForm: "Failed to log in",
    signUpForm: "Failed to sign up",
    signUpOtpForm: "Failed to submit otp",
    signUpOtpFormResendEmailOtp: "Failed to send an otp to your mail id",
    cosellPublishForm: "Failed to generate publish link",
    forgotPasswordForm: "Something went wrong",
    resetPasswordForm: "Failed to change password"
};

export const FORM_SUBMIT_MESSAGE_TEXT_ID = {
    loginForm: `${APP_ID}-login-form-submit-message`,
    signUpForm: `${APP_ID}-sign-up-form-submit-message`,
    signUpOtpForm: `${APP_ID}-sign-up-otp-form-submit-message`,
    cosellPublishForm: `${APP_ID}-cosell-publish-form-submit-message`,
    forgotPasswordForm: `${APP_ID}-forgot-password-form-submit-message`,
    resetPasswordForm: `${APP_ID}-reset-password-form-submit-message`
};

export const FORM_SUBMIT_BUTTON_LOADING_CLASS = `${APP_ID}-button-loading`;

export const APP_EVENT_FORM_RENDERED = "formRendered";
export const APP_EVENT_FORM_REMOVED = "formRemoved";
export const APP_EVENT_MODAL_OPENED = "modalOpened";
export const APP_EVENT_MODAL_CLOSED = "modalClosed";
export const APP_EVENT_MODAL_CLOSED_BY_USER = "modalClosedByUser";
export const APP_EVENT_LOGIN_SUCCESS = "loginSuccess";
export const APP_EVENT_LOGIN_FAILED = "loginFailed";
export const APP_EVENT_SIGN_UP_SUCCESS = "signUpSuccess";
export const APP_EVENT_SIGN_UP_FAILED = "signUpFailed";

export const APP_EVENT_MESSAGE = {
    formRendered: {
        event: "form rendered",
        message: "form rendered by call to renderSTLoginForm()"
    },
    formRemoved: {
        event: "form removed",
        message: "form removed by call to removeSTLoginForm()"
    },
    modalOpened: {
        event: "modal opened",
        message: "modal generated by call to openSTLoginModal()"
    },
    modalClosed: {
        event: "modal closed",
        message: "modal closed by call to closeSTLoginModal()"
    },
    modalClosedByUser: {
        event: "modal closed by user",
        message: "modal closed by clicking on modal close button"
    },
    loginSuccess: {
        event: "login success",
        message: "login successful and token generated"
    },
    loginFailed: {
        event: "login failed",
        message: "login failed and token cannot be generated"
    },
    signUpSuccess: {
        event: "sign-up success",
        message: "sign-up success and token generated"
    },
    signUpFailed: {
        event: "sign-up failed",
        message: "sign-up failed and token cannot be generated"
    }
};

export const COUNTRY_DIAL_CODES = [
    {
        "name": "Afghanistan",
        "dial_code": "+93",
        "code": "AF"
    },
    {
        "name": "Aland Islands",
        "dial_code": "+358",
        "code": "AX"
    },
    {
        "name": "Albania",
        "dial_code": "+355",
        "code": "AL"
    },
    {
        "name": "Algeria",
        "dial_code": "+213",
        "code": "DZ"
    },
    {
        "name": "AmericanSamoa",
        "dial_code": "+1684",
        "code": "AS"
    },
    {
        "name": "Andorra",
        "dial_code": "+376",
        "code": "AD"
    },
    {
        "name": "Angola",
        "dial_code": "+244",
        "code": "AO"
    },
    {
        "name": "Anguilla",
        "dial_code": "+1264",
        "code": "AI"
    },
    {
        "name": "Antarctica",
        "dial_code": "+672",
        "code": "AQ"
    },
    {
        "name": "Antigua and Barbuda",
        "dial_code": "+1268",
        "code": "AG"
    },
    {
        "name": "Argentina",
        "dial_code": "+54",
        "code": "AR"
    },
    {
        "name": "Armenia",
        "dial_code": "+374",
        "code": "AM"
    },
    {
        "name": "Aruba",
        "dial_code": "+297",
        "code": "AW"
    },
    {
        "name": "Australia",
        "dial_code": "+61",
        "code": "AU"
    },
    {
        "name": "Austria",
        "dial_code": "+43",
        "code": "AT"
    },
    {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "code": "AZ"
    },
    {
        "name": "Bahamas",
        "dial_code": "+1242",
        "code": "BS"
    },
    {
        "name": "Bahrain",
        "dial_code": "+973",
        "code": "BH"
    },
    {
        "name": "Bangladesh",
        "dial_code": "+880",
        "code": "BD"
    },
    {
        "name": "Barbados",
        "dial_code": "+1246",
        "code": "BB"
    },
    {
        "name": "Belarus",
        "dial_code": "+375",
        "code": "BY"
    },
    {
        "name": "Belgium",
        "dial_code": "+32",
        "code": "BE"
    },
    {
        "name": "Belize",
        "dial_code": "+501",
        "code": "BZ"
    },
    {
        "name": "Benin",
        "dial_code": "+229",
        "code": "BJ"
    },
    {
        "name": "Bermuda",
        "dial_code": "+1441",
        "code": "BM"
    },
    {
        "name": "Bhutan",
        "dial_code": "+975",
        "code": "BT"
    },
    {
        "name": "Bolivia, Plurinational State of",
        "dial_code": "+591",
        "code": "BO"
    },
    {
        "name": "Bosnia and Herzegovina",
        "dial_code": "+387",
        "code": "BA"
    },
    {
        "name": "Botswana",
        "dial_code": "+267",
        "code": "BW"
    },
    {
        "name": "Brazil",
        "dial_code": "+55",
        "code": "BR"
    },
    {
        "name": "British Indian Ocean Territory",
        "dial_code": "+246",
        "code": "IO"
    },
    {
        "name": "Brunei Darussalam",
        "dial_code": "+673",
        "code": "BN"
    },
    {
        "name": "Bulgaria",
        "dial_code": "+359",
        "code": "BG"
    },
    {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "code": "BF"
    },
    {
        "name": "Burundi",
        "dial_code": "+257",
        "code": "BI"
    },
    {
        "name": "Cambodia",
        "dial_code": "+855",
        "code": "KH"
    },
    {
        "name": "Cameroon",
        "dial_code": "+237",
        "code": "CM"
    },
    {
        "name": "Canada",
        "dial_code": "+1",
        "code": "CA"
    },
    {
        "name": "Cape Verde",
        "dial_code": "+238",
        "code": "CV"
    },
    {
        "name": "Cayman Islands",
        "dial_code": "+ 345",
        "code": "KY"
    },
    {
        "name": "Central African Republic",
        "dial_code": "+236",
        "code": "CF"
    },
    {
        "name": "Chad",
        "dial_code": "+235",
        "code": "TD"
    },
    {
        "name": "Chile",
        "dial_code": "+56",
        "code": "CL"
    },
    {
        "name": "China",
        "dial_code": "+86",
        "code": "CN"
    },
    {
        "name": "Christmas Island",
        "dial_code": "+61",
        "code": "CX"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "dial_code": "+61",
        "code": "CC"
    },
    {
        "name": "Colombia",
        "dial_code": "+57",
        "code": "CO"
    },
    {
        "name": "Comoros",
        "dial_code": "+269",
        "code": "KM"
    },
    {
        "name": "Congo",
        "dial_code": "+242",
        "code": "CG"
    },
    {
        "name": "Congo, The Democratic Republic of the Congo",
        "dial_code": "+243",
        "code": "CD"
    },
    {
        "name": "Cook Islands",
        "dial_code": "+682",
        "code": "CK"
    },
    {
        "name": "Costa Rica",
        "dial_code": "+506",
        "code": "CR"
    },
    {
        "name": "Cote d'Ivoire",
        "dial_code": "+225",
        "code": "CI"
    },
    {
        "name": "Croatia",
        "dial_code": "+385",
        "code": "HR"
    },
    {
        "name": "Cuba",
        "dial_code": "+53",
        "code": "CU"
    },
    {
        "name": "Cyprus",
        "dial_code": "+357",
        "code": "CY"
    },
    {
        "name": "Czech Republic",
        "dial_code": "+420",
        "code": "CZ"
    },
    {
        "name": "Denmark",
        "dial_code": "+45",
        "code": "DK"
    },
    {
        "name": "Djibouti",
        "dial_code": "+253",
        "code": "DJ"
    },
    {
        "name": "Dominica",
        "dial_code": "+1767",
        "code": "DM"
    },
    {
        "name": "Dominican Republic",
        "dial_code": "+1849",
        "code": "DO"
    },
    {
        "name": "Ecuador",
        "dial_code": "+593",
        "code": "EC"
    },
    {
        "name": "Egypt",
        "dial_code": "+20",
        "code": "EG"
    },
    {
        "name": "El Salvador",
        "dial_code": "+503",
        "code": "SV"
    },
    {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "code": "GQ"
    },
    {
        "name": "Eritrea",
        "dial_code": "+291",
        "code": "ER"
    },
    {
        "name": "Estonia",
        "dial_code": "+372",
        "code": "EE"
    },
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "code": "ET"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "dial_code": "+500",
        "code": "FK"
    },
    {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "code": "FO"
    },
    {
        "name": "Fiji",
        "dial_code": "+679",
        "code": "FJ"
    },
    {
        "name": "Finland",
        "dial_code": "+358",
        "code": "FI"
    },
    {
        "name": "France",
        "dial_code": "+33",
        "code": "FR"
    },
    {
        "name": "French Guiana",
        "dial_code": "+594",
        "code": "GF"
    },
    {
        "name": "French Polynesia",
        "dial_code": "+689",
        "code": "PF"
    },
    {
        "name": "Gabon",
        "dial_code": "+241",
        "code": "GA"
    },
    {
        "name": "Gambia",
        "dial_code": "+220",
        "code": "GM"
    },
    {
        "name": "Georgia",
        "dial_code": "+995",
        "code": "GE"
    },
    {
        "name": "Germany",
        "dial_code": "+49",
        "code": "DE"
    },
    {
        "name": "Ghana",
        "dial_code": "+233",
        "code": "GH"
    },
    {
        "name": "Gibraltar",
        "dial_code": "+350",
        "code": "GI"
    },
    {
        "name": "Greece",
        "dial_code": "+30",
        "code": "GR"
    },
    {
        "name": "Greenland",
        "dial_code": "+299",
        "code": "GL"
    },
    {
        "name": "Grenada",
        "dial_code": "+1473",
        "code": "GD"
    },
    {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "code": "GP"
    },
    {
        "name": "Guam",
        "dial_code": "+1671",
        "code": "GU"
    },
    {
        "name": "Guatemala",
        "dial_code": "+502",
        "code": "GT"
    },
    {
        "name": "Guernsey",
        "dial_code": "+44",
        "code": "GG"
    },
    {
        "name": "Guinea",
        "dial_code": "+224",
        "code": "GN"
    },
    {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "code": "GW"
    },
    {
        "name": "Guyana",
        "dial_code": "+595",
        "code": "GY"
    },
    {
        "name": "Haiti",
        "dial_code": "+509",
        "code": "HT"
    },
    {
        "name": "Holy See (Vatican City State)",
        "dial_code": "+379",
        "code": "VA"
    },
    {
        "name": "Honduras",
        "dial_code": "+504",
        "code": "HN"
    },
    {
        "name": "Hong Kong",
        "dial_code": "+852",
        "code": "HK"
    },
    {
        "name": "Hungary",
        "dial_code": "+36",
        "code": "HU"
    },
    {
        "name": "Iceland",
        "dial_code": "+354",
        "code": "IS"
    },
    {
        "name": "India",
        "dial_code": "+91",
        "code": "IN"
    },
    {
        "name": "Indonesia",
        "dial_code": "+62",
        "code": "ID"
    },
    {
        "name": "Iran, Islamic Republic of Persian Gulf",
        "dial_code": "+98",
        "code": "IR"
    },
    {
        "name": "Iraq",
        "dial_code": "+964",
        "code": "IQ"
    },
    {
        "name": "Ireland",
        "dial_code": "+353",
        "code": "IE"
    },
    {
        "name": "Isle of Man",
        "dial_code": "+44",
        "code": "IM"
    },
    {
        "name": "Israel",
        "dial_code": "+972",
        "code": "IL"
    },
    {
        "name": "Italy",
        "dial_code": "+39",
        "code": "IT"
    },
    {
        "name": "Jamaica",
        "dial_code": "+1876",
        "code": "JM"
    },
    {
        "name": "Japan",
        "dial_code": "+81",
        "code": "JP"
    },
    {
        "name": "Jersey",
        "dial_code": "+44",
        "code": "JE"
    },
    {
        "name": "Jordan",
        "dial_code": "+962",
        "code": "JO"
    },
    {
        "name": "Kazakhstan",
        "dial_code": "+77",
        "code": "KZ"
    },
    {
        "name": "Kenya",
        "dial_code": "+254",
        "code": "KE"
    },
    {
        "name": "Kiribati",
        "dial_code": "+686",
        "code": "KI"
    },
    {
        "name": "Korea, Democratic People's Republic of Korea",
        "dial_code": "+850",
        "code": "KP"
    },
    {
        "name": "Korea, Republic of South Korea",
        "dial_code": "+82",
        "code": "KR"
    },
    {
        "name": "Kuwait",
        "dial_code": "+965",
        "code": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "code": "KG"
    },
    {
        "name": "Laos",
        "dial_code": "+856",
        "code": "LA"
    },
    {
        "name": "Latvia",
        "dial_code": "+371",
        "code": "LV"
    },
    {
        "name": "Lebanon",
        "dial_code": "+961",
        "code": "LB"
    },
    {
        "name": "Lesotho",
        "dial_code": "+266",
        "code": "LS"
    },
    {
        "name": "Liberia",
        "dial_code": "+231",
        "code": "LR"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "dial_code": "+218",
        "code": "LY"
    },
    {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "code": "LI"
    },
    {
        "name": "Lithuania",
        "dial_code": "+370",
        "code": "LT"
    },
    {
        "name": "Luxembourg",
        "dial_code": "+352",
        "code": "LU"
    },
    {
        "name": "Macao",
        "dial_code": "+853",
        "code": "MO"
    },
    {
        "name": "Macedonia",
        "dial_code": "+389",
        "code": "MK"
    },
    {
        "name": "Madagascar",
        "dial_code": "+261",
        "code": "MG"
    },
    {
        "name": "Malawi",
        "dial_code": "+265",
        "code": "MW"
    },
    {
        "name": "Malaysia",
        "dial_code": "+60",
        "code": "MY"
    },
    {
        "name": "Maldives",
        "dial_code": "+960",
        "code": "MV"
    },
    {
        "name": "Mali",
        "dial_code": "+223",
        "code": "ML"
    },
    {
        "name": "Malta",
        "dial_code": "+356",
        "code": "MT"
    },
    {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "code": "MH"
    },
    {
        "name": "Martinique",
        "dial_code": "+596",
        "code": "MQ"
    },
    {
        "name": "Mauritania",
        "dial_code": "+222",
        "code": "MR"
    },
    {
        "name": "Mauritius",
        "dial_code": "+230",
        "code": "MU"
    },
    {
        "name": "Mayotte",
        "dial_code": "+262",
        "code": "YT"
    },
    {
        "name": "Mexico",
        "dial_code": "+52",
        "code": "MX"
    },
    {
        "name": "Micronesia, Federated States of Micronesia",
        "dial_code": "+691",
        "code": "FM"
    },
    {
        "name": "Moldova",
        "dial_code": "+373",
        "code": "MD"
    },
    {
        "name": "Monaco",
        "dial_code": "+377",
        "code": "MC"
    },
    {
        "name": "Mongolia",
        "dial_code": "+976",
        "code": "MN"
    },
    {
        "name": "Montenegro",
        "dial_code": "+382",
        "code": "ME"
    },
    {
        "name": "Montserrat",
        "dial_code": "+1664",
        "code": "MS"
    },
    {
        "name": "Morocco",
        "dial_code": "+212",
        "code": "MA"
    },
    {
        "name": "Mozambique",
        "dial_code": "+258",
        "code": "MZ"
    },
    {
        "name": "Myanmar",
        "dial_code": "+95",
        "code": "MM"
    },
    {
        "name": "Namibia",
        "dial_code": "+264",
        "code": "NA"
    },
    {
        "name": "Nauru",
        "dial_code": "+674",
        "code": "NR"
    },
    {
        "name": "Nepal",
        "dial_code": "+977",
        "code": "NP"
    },
    {
        "name": "Netherlands",
        "dial_code": "+31",
        "code": "NL"
    },
    {
        "name": "Netherlands Antilles",
        "dial_code": "+599",
        "code": "AN"
    },
    {
        "name": "New Caledonia",
        "dial_code": "+687",
        "code": "NC"
    },
    {
        "name": "New Zealand",
        "dial_code": "+64",
        "code": "NZ"
    },
    {
        "name": "Nicaragua",
        "dial_code": "+505",
        "code": "NI"
    },
    {
        "name": "Niger",
        "dial_code": "+227",
        "code": "NE"
    },
    {
        "name": "Nigeria",
        "dial_code": "+234",
        "code": "NG"
    },
    {
        "name": "Niue",
        "dial_code": "+683",
        "code": "NU"
    },
    {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "code": "NF"
    },
    {
        "name": "Northern Mariana Islands",
        "dial_code": "+1670",
        "code": "MP"
    },
    {
        "name": "Norway",
        "dial_code": "+47",
        "code": "NO"
    },
    {
        "name": "Oman",
        "dial_code": "+968",
        "code": "OM"
    },
    {
        "name": "Pakistan",
        "dial_code": "+92",
        "code": "PK"
    },
    {
        "name": "Palau",
        "dial_code": "+680",
        "code": "PW"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "dial_code": "+970",
        "code": "PS"
    },
    {
        "name": "Panama",
        "dial_code": "+507",
        "code": "PA"
    },
    {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "code": "PG"
    },
    {
        "name": "Paraguay",
        "dial_code": "+595",
        "code": "PY"
    },
    {
        "name": "Peru",
        "dial_code": "+51",
        "code": "PE"
    },
    {
        "name": "Philippines",
        "dial_code": "+63",
        "code": "PH"
    },
    {
        "name": "Pitcairn",
        "dial_code": "+872",
        "code": "PN"
    },
    {
        "name": "Poland",
        "dial_code": "+48",
        "code": "PL"
    },
    {
        "name": "Portugal",
        "dial_code": "+351",
        "code": "PT"
    },
    {
        "name": "Puerto Rico",
        "dial_code": "+1939",
        "code": "PR"
    },
    {
        "name": "Qatar",
        "dial_code": "+974",
        "code": "QA"
    },
    {
        "name": "Romania",
        "dial_code": "+40",
        "code": "RO"
    },
    {
        "name": "Russia",
        "dial_code": "+7",
        "code": "RU"
    },
    {
        "name": "Rwanda",
        "dial_code": "+250",
        "code": "RW"
    },
    {
        "name": "Reunion",
        "dial_code": "+262",
        "code": "RE"
    },
    {
        "name": "Saint Barthelemy",
        "dial_code": "+590",
        "code": "BL"
    },
    {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "dial_code": "+290",
        "code": "SH"
    },
    {
        "name": "Saint Kitts and Nevis",
        "dial_code": "+1869",
        "code": "KN"
    },
    {
        "name": "Saint Lucia",
        "dial_code": "+1758",
        "code": "LC"
    },
    {
        "name": "Saint Martin",
        "dial_code": "+590",
        "code": "MF"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "dial_code": "+508",
        "code": "PM"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "dial_code": "+1784",
        "code": "VC"
    },
    {
        "name": "Samoa",
        "dial_code": "+685",
        "code": "WS"
    },
    {
        "name": "San Marino",
        "dial_code": "+378",
        "code": "SM"
    },
    {
        "name": "Sao Tome and Principe",
        "dial_code": "+239",
        "code": "ST"
    },
    {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "code": "SA"
    },
    {
        "name": "Senegal",
        "dial_code": "+221",
        "code": "SN"
    },
    {
        "name": "Serbia",
        "dial_code": "+381",
        "code": "RS"
    },
    {
        "name": "Seychelles",
        "dial_code": "+248",
        "code": "SC"
    },
    {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "code": "SL"
    },
    {
        "name": "Singapore",
        "dial_code": "+65",
        "code": "SG"
    },
    {
        "name": "Slovakia",
        "dial_code": "+421",
        "code": "SK"
    },
    {
        "name": "Slovenia",
        "dial_code": "+386",
        "code": "SI"
    },
    {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "code": "SB"
    },
    {
        "name": "Somalia",
        "dial_code": "+252",
        "code": "SO"
    },
    {
        "name": "South Africa",
        "dial_code": "+27",
        "code": "ZA"
    },
    {
        "name": "South Sudan",
        "dial_code": "+211",
        "code": "SS"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "dial_code": "+500",
        "code": "GS"
    },
    {
        "name": "Spain",
        "dial_code": "+34",
        "code": "ES"
    },
    {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "code": "LK"
    },
    {
        "name": "Sudan",
        "dial_code": "+249",
        "code": "SD"
    },
    {
        "name": "Suriname",
        "dial_code": "+597",
        "code": "SR"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "dial_code": "+47",
        "code": "SJ"
    },
    {
        "name": "Swaziland",
        "dial_code": "+268",
        "code": "SZ"
    },
    {
        "name": "Sweden",
        "dial_code": "+46",
        "code": "SE"
    },
    {
        "name": "Switzerland",
        "dial_code": "+41",
        "code": "CH"
    },
    {
        "name": "Syrian Arab Republic",
        "dial_code": "+963",
        "code": "SY"
    },
    {
        "name": "Taiwan",
        "dial_code": "+886",
        "code": "TW"
    },
    {
        "name": "Tajikistan",
        "dial_code": "+992",
        "code": "TJ"
    },
    {
        "name": "Tanzania, United Republic of Tanzania",
        "dial_code": "+255",
        "code": "TZ"
    },
    {
        "name": "Thailand",
        "dial_code": "+66",
        "code": "TH"
    },
    {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "code": "TL"
    },
    {
        "name": "Togo",
        "dial_code": "+228",
        "code": "TG"
    },
    {
        "name": "Tokelau",
        "dial_code": "+690",
        "code": "TK"
    },
    {
        "name": "Tonga",
        "dial_code": "+676",
        "code": "TO"
    },
    {
        "name": "Trinidad and Tobago",
        "dial_code": "+1868",
        "code": "TT"
    },
    {
        "name": "Tunisia",
        "dial_code": "+216",
        "code": "TN"
    },
    {
        "name": "Turkey",
        "dial_code": "+90",
        "code": "TR"
    },
    {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "code": "TM"
    },
    {
        "name": "Turks and Caicos Islands",
        "dial_code": "+1649",
        "code": "TC"
    },
    {
        "name": "Tuvalu",
        "dial_code": "+688",
        "code": "TV"
    },
    {
        "name": "Uganda",
        "dial_code": "+256",
        "code": "UG"
    },
    {
        "name": "Ukraine",
        "dial_code": "+380",
        "code": "UA"
    },
    {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "code": "AE"
    },
    {
        "name": "United Kingdom",
        "dial_code": "+44",
        "code": "GB"
    },
    {
        "name": "United States",
        "dial_code": "+1",
        "code": "US"
    },
    {
        "name": "Uruguay",
        "dial_code": "+598",
        "code": "UY"
    },
    {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "code": "UZ"
    },
    {
        "name": "Vanuatu",
        "dial_code": "+678",
        "code": "VU"
    },
    {
        "name": "Venezuela, Bolivarian Republic of Venezuela",
        "dial_code": "+58",
        "code": "VE"
    },
    {
        "name": "Vietnam",
        "dial_code": "+84",
        "code": "VN"
    },
    {
        "name": "Virgin Islands, British",
        "dial_code": "+1284",
        "code": "VG"
    },
    {
        "name": "Virgin Islands, U.S.",
        "dial_code": "+1340",
        "code": "VI"
    },
    {
        "name": "Wallis and Futuna",
        "dial_code": "+681",
        "code": "WF"
    },
    {
        "name": "Yemen",
        "dial_code": "+967",
        "code": "YE"
    },
    {
        "name": "Zambia",
        "dial_code": "+260",
        "code": "ZM"
    },
    {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "code": "ZW"
    }
];
